import { SET_OVERLAY_MODE } from '../actionConstants';

export const setOverlayModeAction = (payload) => {
  return {
    type: SET_OVERLAY_MODE,
    payload,
  };
};
